import React from "react";
import "./button.css";

interface TextButtonProps {
  label?: string;
  onClick?: () => void;
}

const TextButton: React.FC<TextButtonProps> = ({ label, onClick }) => {
  return (
     <button className="btn-text-primary" onClick={onClick}>
      {label}
    </button>
  );
};

export default TextButton;
